import React from "react";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  deleteAddressByUserId,
  editAddressById,
  getAddressByUserId,
} from "../../../api/common";
import AddAddressModal from "../../modal/AddAddressModal";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { address } from "../../../reducers/users/order";
import { useParams } from "react-router-dom";

const DeliverAddress = ({ item, hide, orderDetail }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();
  const param = useParams();

  const dispatch = useDispatch();
  const [visible, setVisible] = useState();
  const [addVisible, setAddVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const addressObj = useSelector((state) => state.order.address);

  const deleteHandler = (id) => {
    let obj = {
      addressId: id,
    };
    dispatch(deleteAddressByUserId(obj)).then((res) => {
      if (res.statusCode === 200) {
        toast.success("Address Deleted Successfully.");
        dispatch(getAddressByUserId());
      }
    });
  };
  const editHandler = (data) => {
    setVisible(data);
    setAddVisible(true);
  };

  const onFormSubmit = (data) => {
    setLoader(true);
    let apiData = {
      addressId: visible?.id,
      customerName: data?.customerName,
      customerPhone: data?.customerPhone,
      pinCode: data?.pinCode,
      locality: data?.locality,
      address: data?.address,
      country: data?.country,
      state: data?.state,
      city: data?.city,
      landMark: data?.landMark,
      alternatePhone: data?.alternatePhone,
    };
    dispatch(editAddressById(apiData))
      .then((res) => {
        if (res.statusCode === 200)
          toast.success("Address Updated Successfully.");
        setAddVisible(false);
        setLoader(false);
        dispatch(getAddressByUserId());
      })
      .catch((er) => {
        setLoader(false);
      });
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        {param?.id && (
          <div className="me-3">
            <p>
              <span className="ms-1" style={{textTransform: "capitalize"}}>{orderDetail?.address}</span>
              <span className="ms-1">{orderDetail?.landMark}</span>{" "}
              <span className="ms-1">{orderDetail?.city}</span>{" "}
              <span className="ms-1">{orderDetail?.state}</span>{" "}
              <span className="ms-1">{orderDetail?.country}</span>{" "}
              <span className="ms-1">{orderDetail?.pinCode}</span>{" "}
              <span className="ms-1">{orderDetail?.customerPhone}</span>
            </p>
            <p>{item?.customerPhone}</p>
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center">
          {!hide && (
            <input
              type="radio"
              checked={item?.id === addressObj?.id ? true : false}
              onClick={() => dispatch(address(item))}
            />
          )}
          <div className="d-flex flex-column my-3 ms-3">
            <span className="d-flex justify-items-center">
              <h6 className="align-self-center">{item?.customerName}</h6>
            </span>
            <div className="me-3">
              <p className="my-1">
                <span>{item?.address}</span>{" "}
                <span className="ms-1">{item?.landMark}</span>{" "}
                <span className="ms-1">{item?.city}</span>{" "}
                <span className="ms-1">{item?.state}</span>{" "}
                <span className="ms-1">{item?.country}</span>{" "}
                <span className="ms-1">{item?.pinCode}</span>
              </p>
              <p>{item?.customerPhone}</p>
            </div>
          </div>
        </div>
        {!hide && (
          <div className="d-flex justify-content-between">
            <p className="pe-4 cp">
              <FaEdit onClick={() => editHandler(item)} />
            </p>
            <p className="pe-4 cp" onClick={() => deleteHandler(item?.id)}>
              <FaRegTrashAlt />
            </p>
          </div>
        )}
      </div>
      <AddAddressModal
        visible={addVisible}
        header={"Edit Address"}
        setVisible={() => setAddVisible(false)}
        footer={false}
        formData={visible}
        register={register}
        SubmitHandler={handleSubmit(onFormSubmit)}
        errors={errors}
        setValue={setValue}
        loader={loader}
      />
    </>
  );
};
export default DeliverAddress;
